export default __webpack_public_path__ + "985ea2ada6c9e38062b1431407a9ce13.svg";